export enum ClinicTypesEnum {
    digital="digital",
    physical="physical",
    parking="parking"
}
